
import HeroCarousel from './HeroCarousel';

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      <HeroCarousel />

      <div className="relative z-10 text-center px-8 max-w-6xl mx-auto">
        <h1 className="text-7xl lg:text-8xl font-light text-white leading-tight tracking-wide mb-12">
          Making Things,<br />
          Across Every<br />
          Space.
        </h1>

        <div className="max-w-3xl mx-auto mb-16">
          <p className="text-lg text-white/90 leading-relaxed mb-5">
            私たちは「Making Things」を軸に、空間ごとにふさわしいモノ・体験・仕組みを生み出すクリエイティブプロデュースチームです。
          </p>
          <p className="text-base text-white/80 leading-relaxed">
            We are a creative production team focused on "Making Things" across private, public, and global environments.
          </p>
        </div>

        <div className="flex items-center justify-center gap-10">
          <button
            onClick={() => scrollToSection('what-we-do')}
            className="px-12 h-14 bg-white text-black text-sm font-medium rounded-full hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
          >
            事業内容を見る / Explore What We Do
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="px-12 h-14 bg-transparent text-white text-sm font-medium rounded-full border-2 border-white hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
          >
            お問い合わせ / Contact
          </button>
        </div>
      </div>
    </section>
  );
}
